import { TriageRegistrationConfig } from '@eql-ai/typescript-types';
import {
    TriageRegistrationConfigState,
    TriageRegistrationConfigReducerAction,
    TriageRegistrationConfigActionTypes,
} from './types';

export const emptyConfig: TriageRegistrationConfig = {
    enabled: false,
    client_id: '',
    client_name: '',
    provider_route: '',
    ip_reference: '',
    welcome_text: '',
    gp_selection_mode: 'areas_and_gps',
    gps: [],
    areas: [],
    areas_and_gps: [],
    hospitals: [],
    min_patient_age: 18,
    check_ccg_eligibility: false,
    ccgs: [],
};

export const initialTriageRegistrationConfigState: TriageRegistrationConfigState =
    {
        isLoadingProviderConfig: false,
        requestStatus: null,
        config: null,
    };

const triageRegistrationConfigReducer = (
    state = initialTriageRegistrationConfigState,
    action: TriageRegistrationConfigReducerAction,
): TriageRegistrationConfigState => {
    switch (action.type) {
        case TriageRegistrationConfigActionTypes.SET_TRIAGE_REGISTRATION_CONFIG:
            return {
                ...state,
                config: action.payload,
            };
        case TriageRegistrationConfigActionTypes.SET_TRIAGE_REGISTRATION_CONFIG_REQUEST_STATUS: {
            return {
                ...state,
                requestStatus: action.payload,
            };
        }
        default:
            return state;
    }
};

export default triageRegistrationConfigReducer;
